module.exports = __webpack_public_path__ + "static/media/bUSDT-ETH SLP-logo.c8d31097.png";